<template lang="pug">
  a.navbar-brand.goq-header__logo.icon-logo-goqme(href="/")
    h1.d-none GoQme
</template>

<script>
export default {
  name: 'Logo'
}
</script>
